export enum Gender {
  Male,
  Female
}

export enum Language {
  Danish,
  English,
  French,
  German,
  Spanish,
  Icelandic,
  Swedish
}

export enum Speed {
  VerySlow,
  Slow,
  Normal,
  Fast,
  VeryFast
}

export enum ReadingMode {
  Selection,
  Section,
  Document
}

export interface SpeedSelection {
  speed: Speed;
  text: string;
}

export interface VoiceSelection {
  voice: number;
  gender: Gender;
  language: Language;
}

export const DefaultSpeedSelection: SpeedSelection = {
  speed: 3,
  text: 'Normal'
};

export const DefaultVoiceSelection: VoiceSelection = {
  voice: 1,
  gender: Gender.Female,
  language: Language.Danish
};
